"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = require("./styles");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const AppYearRange = ({ options, condSecondInput, onChange, value }) => {
    const [option, setOption] = (0, react_1.useState)();
    const [showSecondInput, setShowSecondInput] = (0, react_1.useState)(false);
    const [input, setInput] = (0, react_1.useState)();
    const [input2, setInput2] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (value && value.option) {
            const selected = options.find(x => x.key === value.option);
            if (selected) {
                setShowSecondInput(condSecondInput(selected));
            }
        }
    }, [value]);
    const handleChangeOption = (0, react_1.useCallback)((e) => {
        const { value: selectedOption } = e.target;
        const selected = options.find(x => x.key === selectedOption);
        if (selected) {
            onChange(Object.assign(Object.assign({}, value), { option: selected === null || selected === void 0 ? void 0 : selected.key }));
            setShowSecondInput(condSecondInput(selected));
        }
    }, [options, onChange, value]);
    return (react_1.default.createElement(styles_1.Container, null,
        react_1.default.createElement(styles_1.InputWrapper, { "$isDouble": showSecondInput },
            react_1.default.createElement(styles_1.RangeInput, { type: "number", maxLength: 4, min: 1000, max: 9999, value: value.start || '', onChange: e => onChange(Object.assign(Object.assign({}, value), { start: e.target.value })) })),
        react_1.default.createElement(styles_1.Select, { value: value.option || '', onChange: handleChangeOption }, options.map(({ key, value }, i) => (react_1.default.createElement("option", { value: key, key: key }, value)))),
        showSecondInput && (react_1.default.createElement(styles_1.InputWrapper, { "$isDouble": showSecondInput },
            react_1.default.createElement(styles_1.RangeInput, { type: "number", maxLength: 4, min: 1000, max: 9999, value: value.end || '', onChange: e => onChange(Object.assign(Object.assign({}, value), { end: e.target.value })) }))),
        value.start || value.end ? (react_1.default.createElement(styles_1.ClearButton, { onClick: () => {
                onChange({
                    start: undefined,
                    end: undefined,
                    option: '='
                });
            } },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTimes }))) : '',
        react_1.default.createElement(styles_1.VisualContainer, null)));
};
exports.default = AppYearRange;
